/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from '@emotion/react';
import PropTypes from 'prop-types';
import { Colors } from 'utils';
const SearchIcon = ({ color, width, height }) => {
  return (
    <svg
      height={`${height || '24'}px`}
      width={`${width || '24'}px`}
      viewBox="0 0 24 24"
      css={css`
        fill: ${color || Colors.black};
        max-width: ${width || '24'}px;
        max-height: ${height || '24'}px;
        height: ${height || '24'}px;
        width: ${width || '24'}px;
      `}
    >
      <g id="surface1">
        <path
          style={{
            stroke: 'none',
            fillRull: 'nonzero',
            fill: 'rgb(0%,0%,0%)',
            fillOpacity: '1',
          }}
          d="M 23.148438 18.914062 L 19.195312 14.960938 C 19.914062 13.527344 20.394531 11.851562 20.394531 10.175781 C 20.394531 4.546875 15.84375 0 10.21875 0 C 4.59375 0 0.0429688 4.546875 0.0429688 10.175781 C 0.0429688 15.800781 4.59375 20.347656 10.21875 20.347656 C 11.894531 20.347656 13.570312 19.871094 15.007812 19.152344 L 18.957031 23.101562 C 20.15625 24.300781 21.949219 24.300781 23.148438 23.101562 C 24.222656 21.90625 24.222656 20.109375 23.148438 18.914062 Z M 10.21875 17.957031 C 5.910156 17.957031 2.4375 14.484375 2.4375 10.175781 C 2.4375 5.867188 5.910156 2.394531 10.21875 2.394531 C 14.527344 2.394531 18 5.867188 18 10.175781 C 18 14.484375 14.527344 17.957031 10.21875 17.957031 Z M 10.21875 17.957031 "
        />
      </g>
    </svg>
  );
};

export default SearchIcon;

SearchIcon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
};
